import { useState, useEffect } from "react"
import Select from "react-select";
import { useUser } from "../utils/UserContext";
import { toast } from 'react-hot-toast';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { formatCurrency } from '../utils/currencyUtils';
import Switch from "react-switch";

function MiniTradeForm({selectedUser}) {
  const { user } = useUser();
  const [tradeTab, setTradeTab] = useState("buy");
  // My trade form
  const [error, setError] = useState(false);
  const usdbal = selectedUser.balance;
  const [tradeDetails, setTradeDetails] = useState([]);
  const [type, setType] = useState("crypto");
  const [trade, setTrade] = useState("BTC");
  const [coinbal, setCoinbal] = useState([]);
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(true);
  const typeoptions = [
    { value: "crypto", label: "Crypto" },
    { value: "forex", label: "Forex" },
    { value: "stocks", label: "Stocks" },
  ];
  const durationoptions = [
    { value: "2 mins", label: "2 Minutes" },
    { value: "5 mins", label: "5 Minutes" },
    { value: "10 mins", label: "10 Minutes" },
    { value: "30 mins", label: "30 Minutes" },
    { value: "1 hour", label: "1 Hours" },
    { value: "2 hours", label: "2 Hours" },
    { value: "4 hours", label: "4 Hours" },
    { value: "6 hours", label: "6 Hours" },
    { value: "8 hours", label: "7 Hours" },
    { value: "10 hours", label: "10 Hours" },
    { value: "20 hours", label: "20 Hours" },
    { value: "1 day", label: "1 Day" },
    { value: "2 days", label: "2 Days" },
    { value: "3 days", label: "3 Days" },
    { value: "4 days", label: "4 Days" },
    { value: "5 days", label: "5 Days" },
    { value: "6 days", label: "6 Days" },
    { value: "1 Week", label: "1 Week" },
    { value: "2 Weeks", label: "2 Weeks" },
  ];
  const darkThemeStyles1 = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "rgb(30, 33, 36)",
      border: "none",
      color: "#fff",
      fontWeight: '600',
    }),
    menu: (styles) => ({
      ...styles,
      backgroundColor: "rgb(30, 33, 36)",
      fontWeight: '600',
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? "#151719" : isFocused ? "#151719" : "rgb(30, 33, 36)",
      color: "#fff",
      fontWeight: '600',
    }),
    singleValue: (styles) => ({
      ...styles,
      color: "#fff",
      fontWeight: '600',
    }),
  };
  const darkThemeStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
      border: "none",
      color: "#fff",
    }),
    menu: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",
      color: "#fff",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: "#fff",
    }),
  };
  const [crypto, setCrypto] = useState([]);    
  const [fiat, setFiat] = useState([]);
  const [stock, setStock] = useState([]);
  const [wallet, setWallet] = useState([]);
  const [assethistory, setAssethistory] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchwallet1: true, user : selectedUser.email })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setWallet(data.wallet);
      }
    })
    .catch(err => {
      
    })
  }, [user]);
  useEffect(() => {
      fetch(`/coin_list.txt`)
      .then((res) => res.json())
      .then((data) => {
      var coinList = data.data.sort((a, b) => a.name.localeCompare(b.name));
      const updatedData = coinList.map((coin, index) => {
        const walletItem = wallet.find(item => item.coinName === coin.name);
        return {
          id: index + 1,
          label: <><img src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`} alt={coin.symbol} width="20" /> {coin.symbol}</>,
          name: coin.name,
          price: Number(coin.quote.USD.price.toFixed(2)),
          value: coin.symbol,
          balance: walletItem ? walletItem.balance : 0,
        };
      });
      setCrypto(updatedData);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, [wallet]);
  useEffect(() => {
    fetch(`/stock_list.txt`)
    .then((res) => res.json())
    .then((data) => {
    const stockList = Object.values(data).sort((a, b) => a.name.localeCompare(b.name));
    const updatedData = stockList.map((stock, index) => {
      const walletItem = wallet.find(item => item.coinName === stock.name);
      return {
        id: index + 1,
        name: stock.name,
        label: <><img src={`https://images.financialmodelingprep.com/symbol/${stock.symbol}.png`} alt={stock.symbol} width="20" /> {stock.symbol}</>,
        value: stock.symbol,
        price: Number(stock.price.toFixed(2)),
        balance: walletItem ? walletItem.balance : 0,
      };
    });
    setStock(updatedData);
    })
    .catch((err) => console.error("Error loading coin list:", err));
  }, [wallet]);
  useEffect(() => {   
      fetch(`/fiat_list.txt`)
      .then((res) => res.json())
      .then((data) => {
        const wantedCurrencies = {
          AUD: 'Australian Dollar',
          CAD: 'Canadian Dollar',
          CHF: 'Swiss Franc',
          CNY: 'Chinese Yuan',
          EUR: 'Euro',
          GBP: 'British Pound',
          INR: 'Indian Rupee',
          JPY: 'Japanese Yen',
          RUB: 'Russian Ruble',
          USD: 'US Dollar',
          ZAR: 'South African Rand'
        };
        const fiatList = Object.entries(data)
          .filter(([code]) => wantedCurrencies.hasOwnProperty(code))
          .map(([code, value], index) => {
            const walletItem = wallet.find(item => item.coinName === wantedCurrencies[code]);
            return {
              id: index + 1,
              value: code,
              name: wantedCurrencies[code],
              price: Number(value),
              label: <><img src={`https://flagcdn.com/w40/${code.slice(0, 2).toLowerCase()}.png`} alt={code} width="20" /> {code}</>,
              balance: walletItem ? walletItem.balance : 0,
            };
          })
          .sort((a, b) => a.name.localeCompare(b.name));
        
        setFiat(fiatList);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, [wallet]);
  useEffect(() => {
    const tradeDetails = type === "crypto" 
      ? crypto.find(opt => opt.value === trade) 
      : type === "forex" 
        ? fiat.find(opt => opt.value === trade) 
        : stock.find(opt => opt.value === trade);
    if (tradeDetails) {
      setTradeDetails(tradeDetails);
      setCoinbal(tradeDetails.balance);
    } else {
      setTradeDetails([]);
      setCoinbal(0);
    }
  }, [crypto, fiat, stock, type, trade]);
  const [amount, setAmount] = useState();
  const [amount1, setAmount1] = useState();
  const [duration, setDuration] = useState("2 mins");

  const pnlList = [
    { value: "Profit", label: "Profit" },
    { value: "Loss", label: "Loss" },
  ];
  const [checked, setChecked] = useState();
  const [pnlType, setPnlType] = useState("Profit");
  const [tradepnl, setTradepnl] = useState();

  useEffect(() => {
    if((amount || amount1) && duration && !error){
      setDisable(false);
    }else{
      setDisable(true);
    }
  }, [amount, amount1, duration]);
  useEffect(() => {
    if (!crypto.length && !fiat.length && !stock.length) return;
    const merged = [
      ...crypto,
      ...fiat,
      ...stock
    ];
    const sorted = merged.sort((a, b) => a.name.localeCompare(b.name));
    setAssethistory(sorted);
  }, [crypto, fiat, stock]);

  function handleBuy(){
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ btn_trade: true, email:selectedUser.email, type: type, amount: amount, pair: trade + (type === "crypto" ? "/USDT" : type === "forex" ? "/USD" : ""), action: "Buy", entry: tradeDetails.price, tf: duration, coinname: tradeDetails.name, pnlType : pnlType, pnl : tradepnl})
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        toast.success(data.result);
        setTimeout(() => {
            window.location.href = "manage";
          }, 2000);
      }else{
        toast.error(data.message);
      }
      setLoading(false);
    })
    .catch(err => {
      console.error(err)
      setLoading(false);
    })
  }
  function handleSell(){
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ btn_trade: true, email:selectedUser.email, type: type, amount: amount1, pair: trade + (type === "crypto" ? "/USDT" : type === "forex" ? "/USD" : ""), action: "Sell", entry: tradeDetails.price, tf: duration, coinname: tradeDetails.name, pnlType : pnlType, pnl : tradepnl})
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        toast.success(data.result);
        setTimeout(() => {
            window.location.href = "manage";
          }, 2000);
      }else{
        toast.error(data.message);
      }
      setLoading(false);
    })
    .catch(err => {
      console.error(err)
      setLoading(false);
    })
  }

  //SWAP CODE
  const [loading1, setLoading1] = useState(false);
  const [disable1, setDisable1] = useState(true);
  const [swapAmountOne, setSwapAmountOne] = useState();
  const [swapAmountTwo, setSwapAmountTwo] = useState("0.0000");
  const [swapOne, setSwapOne] = useState(assethistory[10] ? assethistory[10].value : "BTC");
  const [swapTwo, setSwapTwo] = useState(assethistory[20] ? assethistory[20].value : "ETH");
  const [swapOneDetails, setSwapOneDetails] = useState([]);
  const [swapTwoDetails, setSwapTwoDetails] = useState([]);
  useEffect(() => {
    if(swapAmountOne && swapAmountTwo && !error){
      setDisable1(false);
    }else{
      setDisable1(true);
    }
  }, [swapAmountOne, swapAmountTwo, error]);
  useEffect(() => {
    const swapOneDetails = assethistory.find(opt => opt.value === swapOne);
    if (swapOneDetails) {
      setSwapOneDetails(swapOneDetails);
    } else {
      setSwapOneDetails([]);
    }
    const swapTwoDetails = assethistory.find(opt => opt.value === swapTwo);
    if (swapTwoDetails) {
      setSwapTwoDetails(swapTwoDetails);
    } else {
      setSwapTwoDetails([]);
    }
  }, [assethistory, swapOne, swapTwo]);

  function validateSwapOne({ value, swaponeprice, swaptwoprice, swaponebalance, twoSymbol }){
    var amount = (value ?? swapAmountOne);
    var swapOneUSd = amount * (swaponeprice ?? swapOneDetails.price);
    var swayTwoSymbol = (twoSymbol ?? swapTwo);
    const wantedCurrencies = {
      AUD: 'Australian Dollar',
      CAD: 'Canadian Dollar',
      CHF: 'Swiss Franc',
      CNY: 'Chinese Yuan',
      EUR: 'Euro',
      GBP: 'British Pound',
      INR: 'Indian Rupee',
      JPY: 'Japanese Yen',
      RUB: 'Russian Ruble',
      USD: 'US Dollar',
      ZAR: 'South African Rand'
    };
    const isFiat = wantedCurrencies.hasOwnProperty(swayTwoSymbol);
    if (isFiat) {
      var swapTwoAmt = swapOneUSd / (1 / (swaptwoprice ?? swapTwoDetails.price));
    } else {
      var swapTwoAmt = swapOneUSd / (swaptwoprice ?? swapTwoDetails.price);
    }
    setSwapAmountTwo(swapTwoAmt);
    if (
      Number(amount) > Number(swaponebalance ?? swapOneDetails.balance) || 
      Number(swaponebalance ?? swapOneDetails.balance) === 0
    ) {
      setError(true);
    }else{
      setError(false);
    }
  }
  function handleSwap(){
    setLoading1(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ btn_swap: true, email:selectedUser.email, swapAmountOne : swapAmountOne, swapAmountTwo: swapAmountTwo, swapCoinOne : swapOneDetails.name, swapCoinTwo: swapTwoDetails.name, swapSymbolOne : swapOneDetails.value, swapSymbolTwo: swapTwoDetails.value, swapPriceOne: swapOneDetails.price}) 
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        toast.success(data.result);
        setTimeout(() => {
            window.location.href = "manage";
          }, 2000);
      }else{
        toast.error(data.message);
      }
      setLoading1(false);
    })
    .catch(err => {
      console.error(err)
      setLoading1(false);
    })
  }

  return (
    <div className="mt-4">
        <div className="mytab justify-content-between">
          <div className={`mytab-item buy ${tradeTab === "buy" ? 'active' : ''}`} style={{width: '33%'}} onClick={() => {
            setTradeTab("buy")}}>Buy</div>
          <div className={`mytab-item sell ${tradeTab === "sell" ? 'active' : ''}`} style={{width: '33%'}} onClick={() => {
            setTradeTab("sell")}}>Sell</div>
          <div className={`mytab-item ${tradeTab === "convert" ? 'active' : ''}`} style={{width: '33%'}} onClick={() => {
            setTradeTab("convert")}}>Convert</div>
        </div>
        {tradeTab === "buy" && (
        <div className="mt-2">
          <label className="fw-semibold mb-1" style={{fontSize: '14px'}}>Type:</label>
          <Select 
            options={typeoptions} 
            value={typeoptions.find((opt) => opt.value === type)}
            onChange={(e) => {
              setType(e.value);
              setTrade(e.value === "crypto" ? crypto[0].value : e.value === "forex" ? fiat[0].value : stock[0].value);
            }}
            styles={darkThemeStyles}
            className="w-full"
          />
          <label className="fw-semibold mb-1 mt-2" style={{fontSize: '14px'}}>Amount:</label>
          <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 ${error ? 'input-error' : ''}`}>
            <input 
              type="text" 
              placeholder="100" 
              className="inputNone"
              value={amount}
              onChange={(e) => {setAmount(e.target.value);}}
            />
            <Select 
              options={type === "crypto" ? crypto : type === "forex" ? fiat : stock} 
              value={(type === "crypto" ? crypto : type === "forex" ? fiat : stock).find(opt => opt.value === trade)}
              onChange={(e) => setTrade(e.value)}
              isSearchable
              styles={darkThemeStyles1}
              className="w-full"
            />
          </div>
          {error && (
          <p className="mb-0 text-danger fs-7 mt-1">Buying {trade} will take out balance from your USD account and purchase {trade} with it. Your USD balance is below the amout you have selected.</p>
          )}
          <div className="d-flex align-items-center justify-content-between mt-1">
            <p className="mb-0 fs-7 text-white">Current USD balance:</p>
            <p className="mb-0 fs-7 text-white">{formatCurrency(usdbal)} USD</p>
          </div>
          <div className="d-flex align-items-center justify-content-between mt-0">
            <p className="mb-0 fs-7 text-white">Current {trade} price</p>
            <p className="mb-0 fs-7 text-success">${formatCurrency(tradeDetails.price)}</p>
          </div>
            <label className="fw-semibold mt-2" style={{fontSize: '14px'}}>Pnl:</label>
            <div className="d-flex align-items-between form-control justify-content-between py-2">
                <label className="fw-semibold mb-0" style={{fontSize: '14px'}}>Add profits or loss to this trade</label>
                <Switch
                    onChange={() => setChecked(!checked)}
                    checked={checked}
                    offColor="#404448"
                    onColor="#404448"
                    offHandleColor="#8c95a0"
                    onHandleColor="#ff6b35"
                    uncheckedIcon={false}
                    checkedIcon={false}
                    height={23}
                    width={40}
                    handleDiameter={18}
                />
            </div>
          {checked && (
            <>
                <label className="fw-semibold mt-2" style={{fontSize: '14px'}}>{pnlType} amount (USD):</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 ${error ? 'input-error' : ''}`}>
                    <input 
                        type="text" 
                        placeholder={`How much ${pnlType} do you want to add?`}
                        className="inputNone"
                        value={tradepnl}
                        onChange={(e) => setTradepnl(e.target.value)}
                    />
                    <Select 
                        options={pnlList} 
                        value={pnlList.find((opt) => opt.value === pnlType)}
                        onChange={(e) => {setPnlType(e.value)}}
                        styles={darkThemeStyles1}
                        className="w-full"
                    />
                </div>
            </>
          )}
          <label className="fw-semibold mt-2" style={{fontSize: '14px'}}>Duration:</label>
          <Select 
            options={durationoptions} 
            value={durationoptions.find((opt) => opt.value === duration)}
            onChange={(e) => setDuration(e.value)}
            styles={darkThemeStyles}
            className="w-full"
          />
          <div className={`myBtn w-100 text-center mt-4 ${disable?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!disable ? handleBuy : null}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Buy'}</div>
        </div>
        )}
        {tradeTab === "sell" && (
        <div className="mt-2">
          <label className="fw-semibold mb-1" style={{fontSize: '14px'}}>Type:</label>
          <Select 
            options={typeoptions} 
            value={typeoptions.find((opt) => opt.value === type)}
            onChange={(e) => {
              setType(e.value);
              setTrade(e.value === "crypto" ? crypto[0].value : e.value === "forex" ? fiat[0].value : stock[0].value);
            }}
            styles={darkThemeStyles}
            className="w-full"
          />
          <label className="fw-semibold mb-1 mt-2" style={{fontSize: '14px'}}>Amount:</label>
          <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 ${error ? 'input-error' : ''}`}>
            <input 
              type="text" 
              placeholder={(100 / tradeDetails.price).toFixed(4)} 
              className="inputNone"
              value={amount1}
              onChange={(e) => {setAmount1(e.target.value);}}
            />
            <Select 
              options={type === "crypto" ? crypto : type === "forex" ? fiat : stock} 
              value={(type === "crypto" ? crypto : type === "forex" ? fiat : stock).find(opt => opt.value === trade)}
              onChange={(e) => setTrade(e.value)}
              isSearchable
              styles={darkThemeStyles1}
              className="w-full"
            />
          </div>
          {error && (
          <p className="mb-0 text-danger fs-7 mt-1">Selling {trade} will take out balance from your {trade} account and trade USD with it. Your {trade} balance is below the amout you have selected.</p>
          )}
          <div className="d-flex align-items-center justify-content-between mt-1">
            <p className="mb-0 fs-7 text-white">Current {trade} balance:</p>
            <p className="mb-0 fs-7 text-white">{formatCurrency(coinbal)} {trade}</p>
          </div>
          <div className="d-flex align-items-center justify-content-between mt-0">
            <p className="mb-0 fs-7 text-white">Current {trade} price</p>
            <p className="mb-0 fs-7 text-success">${formatCurrency(tradeDetails.price)}</p>
          </div>
          <label className="fw-semibold mt-2" style={{fontSize: '14px'}}>Pnl:</label>
            <div className="d-flex align-items-between form-control justify-content-between py-2">
                <label className="fw-semibold mb-0" style={{fontSize: '14px'}}>Add profits or loss to this trade</label>
                <Switch
                    onChange={() => setChecked(!checked)}
                    checked={checked}
                    offColor="#404448"
                    onColor="#404448"
                    offHandleColor="#8c95a0"
                    onHandleColor="#ff6b35"
                    uncheckedIcon={false}
                    checkedIcon={false}
                    height={23}
                    width={40}
                    handleDiameter={18}
                />
            </div>
          {checked && (
            <>
                <label className="fw-semibold mt-2" style={{fontSize: '14px'}}>{pnlType} amount (USD):</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 ${error ? 'input-error' : ''}`}>
                    <input 
                        type="text" 
                        placeholder={`How much ${pnlType} do you want to add?`}
                        className="inputNone"
                        value={tradepnl}
                        onChange={(e) => setTradepnl(e.target.value)}
                    />
                    <Select 
                        options={pnlList} 
                        value={pnlList.find((opt) => opt.value === pnlType)}
                        onChange={(e) => {setPnlType(e.value)}}
                        styles={darkThemeStyles1}
                        className="w-full"
                    />
                </div>
            </>
          )}
          <label className="fw-semibold mb-1" style={{fontSize: '14px'}}>Duration:</label>
          <Select 
            options={durationoptions} 
            value={durationoptions.find((opt) => opt.value === duration)}
            onChange={(e) => setDuration(e.value)}
            styles={darkThemeStyles}
            className="w-full"
          />
          <div className={`myBtn w-100 text-center mt-4 ${disable?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!disable ? handleSell : null}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Sell'}</div>
        </div>
        )}
        {tradeTab === "convert" && (
        <div className="mt-2">
          <label className="fw-semibold mb-1 mt-2" style={{fontSize: '14px'}}>From:</label>
          <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 ${error ? 'input-error' : ''}`}>
            <input 
              type="text" 
              placeholder={swapOneDetails ? (100 / swapOneDetails.price).toFixed(4) : '0.03'}
              className="inputNone"
              value={swapAmountOne}
              onChange={(e) => {setSwapAmountOne(e.target.value); validateSwapOne({ value : e.target.value })}}
            />
            <Select 
              options={assethistory} 
              value={assethistory.find((opt) => opt.value === swapOne)}
              onChange={(e) => {
                setSwapOne(e.value);
                setCoinbal(e.balance);
                const swapOneDetails = assethistory.find(opt => opt.value === e.value);
                if (swapOneDetails) {
                  setSwapOneDetails(swapOneDetails);
                  validateSwapOne({ swaponeprice : swapOneDetails.price, swaponebalance : swapOneDetails.balance })
                } else {
                  setSwapOneDetails([]);
                }
              }}
              isSearchable
              styles={darkThemeStyles1}
              className="w-full"
            />
          </div>
          {error && (
          <p className="mb-0 text-danger fs-7 mt-1">Your current balance is {formatCurrency(swapOneDetails ?swapOneDetails.balance:0)} {swapOne}. You have selected an amount greater than your current balance.</p>
          )}
          <div className="d-flex align-items-center justify-content-between mt-1">
            <p className="mb-0 fs-7 text-white">Current {swapOne} balance:</p>
            <p className="mb-0 fs-7 text-white">{formatCurrency(swapOneDetails ?swapOneDetails.balance:0)} {swapOne}</p>
          </div>
          <div className="d-flex align-items-center justify-content-between mt-0">
            <p className="mb-0 fs-7 text-white">Current {swapOne} price</p>
            <p className="mb-0 fs-7 text-success">${formatCurrency(swapOneDetails ?swapOneDetails.price:0)}</p>
          </div>
          <label className="fw-semibold mb-1 mt-2" style={{fontSize: '14px'}}>To:</label>
          <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1`}>
            <input 
              type="text" 
              className="inputNone"
              value={swapAmountTwo}
              readOnly
            />
            <Select 
              options={assethistory} 
              value={assethistory.find((opt) => opt.value === swapTwo)}
              onChange={(e) => {
                setSwapTwo(e.value);
                const swapTwoDetails = assethistory.find(opt => opt.value === e.value);
                if (swapTwoDetails) {
                  setSwapTwoDetails(swapTwoDetails);
                  validateSwapOne({ swaptwoprice : swapTwoDetails.price, twoSymbol : swapTwoDetails.value })
                } else {
                  setSwapTwoDetails([]);
                }
              }}
              isSearchable
              styles={darkThemeStyles1}
              className="w-full"
            />
          </div>
          <div className="d-flex align-items-center justify-content-between mt-3">
            <p className="mb-0 fs-7 text-white">Current {swapTwo} balance:</p>
            <p className="mb-0 fs-7 text-white">{formatCurrency(swapTwoDetails ?swapTwoDetails.balance:0)} {swapTwo}</p>
          </div>
          <div className="d-flex align-items-center justify-content-between mt-0">
            <p className="mb-0 fs-7 text-white">Current {swapTwo} price</p>
            <p className="mb-0 fs-7 text-success">${formatCurrency(swapTwoDetails ?swapTwoDetails.price:0)}</p>
          </div>
          <div className={`myBtn w-100 text-center mt-4 ${disable1?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!disable1 ? handleSwap : null}>{loading1?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Convert'}</div>
        </div>
        )}
    </div>
    )
  }
  
  export default MiniTradeForm